import request from "@/utils/request";
import requestOMS from "@/utils/oms-request"
import { PackCustomsPackingInput } from "@/model/HqPackingListModels";
import qs from "qs";
import download from "@/utils/download";


export const getPackingLists = (deliveryNoteId: string, params: any) =>
  request({
    url: `/hq-packing-lists`,
    method: "get",
    params
  });

export const getPackingListsWithFactoryLoadingPlan = (id: string, params: any) =>
  request({
    url: `factory-loading-plans/${id}/hq-packing-lists`,
    method: "get",
    params
  });

export const uploadPackingList = (data: FormData) =>
  request({
    headers: { "Content-Type": "multipart/form-data" },
    url: "/hq-packing-lists/excel",
    method: "post",
    data: data
  });

export const reUploadPackingList = (id: string, data: FormData) =>
  request({
    url: `/hq-packing-lists/${id}/excel`,
    method: "post",
    data
  });

export const updatePackingListFile = (id: string, data: FormData) =>
  request({
    url: `/hq-packing-lists/${id}/excel/update`,
    method: "post",
    data
  });


export const getHqPackingListStates = () =>
  request({
    url: "/hq-packing-list-states",
    method: "get"
  });

export const batchDeleteHqPackingList = (data: { ids: string[] }) =>
  request({
    url: "/hq-packing-lists",
    method: "delete",
    data
  });

export const getHqPackingListDetail = (id: string, toAuditable:boolean) =>
  request({
    url: `/hq-packing-lists/${id}?toAuditable=${toAuditable}`,
    method: "get"
  });

// 检查装箱单是否在交货校验中，在交货校验中的装箱单无法查看详情
export const canSeeDetail = (id: string) =>
    request({
        url: `/hq-packing-lists/${id}/customs-packing/created`,
        method: "get",
    });

export const getHqPackingListPackages = (id: string) =>
  request({
    url: `/hq-packing-lists/${id}/packages`,
    method: "get"
  });

export const getHqPackingListDetailForEdit = (id: string) =>
  request({
    url: `/hq-packing-lists/${id}/editable`,
    method: "get"
  });

export const getHqPackingListsPackages = (params: { ids: string }) =>
  request({
    url: `/hq-packing-lists/packages`,
    method: "GET",
    params
  });

export const updateDeliveryTime = (data: { deliveryStartTime: string, deliveryEndTime: string }) =>
  request({
    url: `hq-packing-lists/delivery-time`,
    method: "put",
    data
  });

export const createDeliveryTime = (data: { deliveryStartTime: string, deliveryEndTime: string }) =>
  request({
    url: `hq-packing-lists/delivery-time`,
    method: "post",
    data
  });

export const addRemark = (id: string, data: { remark: string }) =>
  request({
    url: `hq-packing-lists/${id}/remark`,
    method: "put",
    data
  });

export const getHqPackingListsForAudit = (params: any) =>
  request({
    url: `/hq-packing-lists/auditable`,
    method: "get",
    params
  });

export const getHqPackingListAuditStateList = () =>
  request({
    url: "/hq-packing-list-audit-states",
    method: "get"
  });

export const getHqPackingListDetailInfo = (id: string) =>
  request({
    url: `/hq-packing-lists/${id}/detail-info`,
    method: "get"
  });

export const audit = (id: string, data: { auditState, hqPackingListAuditAmounts, auditComment?: string }) =>
  request({
    url: `hq-packing-lists/${id}/audit-state`,
    method: "put",
    data
  });

export const updateAuditComment = (id: string, data: { auditComment: string }) =>
  request({
    url: `hq-packing-lists/${id}/audit-comment`,
    method: "put",
    data
  });

export const queryForConfirmScanning = (id: string) =>
  request({
    url: `/hq-packing-lists/${id}/customs-packing-and-products`,
    method: "get"
  });

export const writeHqPackingListPackage = (id: string, data: PackCustomsPackingInput) =>
  request({
    url: `/hq-packing-lists/${id}/packages`,
    method: "post",
    data
  });

export const getImmutableInfo = (params: any) =>
  request({
    url: `/factory-delivery-notes/original-information`,
    method: "get",
    params
  });

export const downloadHqPackingList = (params: {hqPackingListIds: string[]}) =>
  request({
    url: "/hq-packing-lists/excel",
    method: "get",
    params,
    paramsSerializer: params => qs.stringify(params, { arrayFormat: "repeat" })
  });

export const updateHqPackingListFile = (params: {hqPackingListId: string}) =>
  request({
    url: "/hq-packing-lists/update-packing-file",
    method: "put",
    params,
    paramsSerializer: params => qs.stringify(params, { arrayFormat: "repeat" })
  });

export const fetchDetailsOfOssUrls = (params: {ossIds: string[]}) =>
request({
  url: "/hq-packing-lists/ossUrls",
  method: "get",
  params,
  paramsSerializer: params => qs.stringify(params, { arrayFormat: "repeat" })
});

export const deleteBulkProduct = (productId: string) =>
  request({
    url: `/hq-packing-lists/products/${productId}`,
    method: "DELETE"
  });

export const searchCustomerHqPackingList = (customerId: string, params: { companyCode: string }) =>
  request({
    url: `/${customerId}/hq-packing-lists`,
    method: "GET",
    params
  });

export const getProducts = (hqPackingListId: string, purchaseOrderNumber: string, declarationDescription: string) =>
  request({
    url: `/hq-packing-lists/${hqPackingListId}/${purchaseOrderNumber}/${declarationDescription}/products`,
    method: "GET"
  });

export const editPrice = (id:string ,data: { adjustedProductInfos: any }) =>
  request({
    url: `/hq-packing-lists/${id}/products/unit-price`,
    method: "PUT",
    data
  });

export const getProblemPackingInfo = (id: string) =>
  request({
    url: `/hq-packing-list/${id}/problem-customs-packing`,
    method: "GET"
  });

export const cancelAudit = (id: string) =>
    request({
        url:`/hq-packing-lists/${id}/cancel-audit`,
        method:"PUT"
    });

export const downloadInventoryListExcel = (code: string) =>
    download({
        responseType: "blob",
        url:`/inventory-lists/excel`,
        method:"GET",
        params: {hqPackingListCode: code}
    })

export const downloadMatchResult = (code: string) =>
    download({
        responseType: "blob",
        url:`/inventory-lists/result`,
        method:"GET",
        params: {hqPackingListCode: code}
    })

export const doMatch = (data: {hqPackingListCode: string}) =>
    request({
        url:`/inventory-lists/match`,
        method:"POST",
        data
    })

export const getInventoryList = (code: string) =>
    request({
        url:`/inventory-lists`,
        method:"GET",
        params: {hqPackingListCode: code}
    })

export const deleteInventoryList = (inventoryListId: string,data: {hqPackingListCode: string}) =>
    request({
        url:`/inventory-lists/${inventoryListId}`,
        method:"DELETE",
        data
    })

export const confirmWarehousing = (data: {ids: string[], confirmType?:number}) =>
    request({
        url:`/hq-packing-lists/state`,
        method:"PUT",
        data
    })

export const createEmptyHqPackingList = (data: any) =>
    request({
        url:`/hq-packing-lists`,
        method:"PUT",
        data
    })

export const updateInventoryList = (id:string, data: any) =>
    request({
        url:`/inventory-lists/${id}/product-info`,
        method:"PUT",
        data
    })
export const getCustomsPackingInfoWithCombiningDifferentPackingList = (id: string,params) =>
    request({
        url: `/hq-packing-lists/${id}/new-customs-packing-original-info`,
        method: "GET",
        params
    })
export const updateMoneyList = (data: any) =>
    request({
        url:`/hq-packing-lists/money-list`,
        method: "PUT",
        data
    })

export const getAllHqPackingList = (params: any) =>
    request({
        url: `/hq-packing-lists/management`,
        method: "GET",
        params
    })

export const getFactoryListByAbbreviation = (params: any) =>
    request({
        url: `/suppliers/abbreviation`,
        method: "GET",
        params
    })
export const updateAccountPeriodStartTime = ( packingListId: string, data: any) =>
    request({
        url:`/factory-loading-plans/packing-lists/${packingListId}/account-period-time`,
        method: "PUT",
        data:{startTime: data}
    })

  // /hq-packing-lists/{id}/products-batch
  export const getProductsBatch = (id: any) =>
    request({
        url: `/hq-packing-lists/products/${id}/batch`,
        method: "GET"
    })
  // /hq-packing-lists/{id}/products-batch
  export const putProductsBatch = (id: any,params) =>
  request({
      url: `/hq-packing-lists/${id}/products-batch`,
      method: "put",
      params
  })

export const recordHqPackingListAccountingPeriod = () =>
  request({
    url: `/hq-packing-lists/record-accounting-period`,
    method: "put"
  })

  // hq-packing-lists/{id}/can-re-upload
  // 调用接口成功不报错跳转上传工厂箱单页面
  export const getCanReUpload = (id: any) =>
  request({
      url: `hq-packing-lists/${id}/can-re-upload`,
      method: "get",
  })

  // /hq-packing-lists/{id}/mark-error-status
  // 标记入库待处置接口
  export const markErrorStatus = (id) =>
  request({
      url: `/hq-packing-lists/${id}/mark-error-status`,
      method: "put",
  })

  // 获取是否可操作
  // /hq-packing-lists/{id}/can-other-management
  export const getCanOtherManagement = (id: any) =>
  request({
      url: `/hq-packing-lists/${id}/can-other-management`,
      method: "get",
  })
// /hq-packing-list/{packingListId}/amount-distribution
export const getAmountDistribution = (packingListId: any) =>
  requestOMS({
      url: `/payment_voucher/hq-packing-list/${packingListId}/amount-distribution`,
      method: "get",
  })

  // /hq-packing-list-states-customer-packing-management
  export const getCustomerPackingManagement = () =>
    request({
        url: `/hq-packing-list-states-customer-packing-management`,
        method: "get",
    })

// /hq-packing-lists/code-keyword/account-period lms
export const getAccountPeriod = (params) =>
  request({
      url: `/hq-packing-lists/code-keyword/account-period`,
      method: "get",
      params
  })

// /settlement-period/optional oms
export const postOptional = (data) =>
  requestOMS({
      url: `/payment_voucher/settlement-period/optional`,
      method: "post",
      data
  })

export const leaveToPurchasing = (id: string) =>
    request({
        url: `/hq-packing-lists/${id}/purchaser-handle`,
        method: "put",
    })

// /hq-packing-lists/{id}/shipping-mark // 更新装箱单唛头
export const updateMark = (id: string, remark:string) =>
    request({
        url: `/hq-packing-lists/${id}/shipping-mark`,
        method: "put",
        data:{
          remark
        }
    })

// /hq-packing-lists/{id}/shipping-mark // 回显装箱单唛头
export const getMark = (id: string) =>
    request({
        url: `/hq-packing-lists/${id}/shipping-mark`,
        method: "get"
    });

export const checkCanPurchaseOrderFee = (params) =>
    requestOMS({
        url: `/purchase-order-other-fee/hq-packing-lists/can-purchase-order-fee`,
        method: "get",
        params,
    })
/**
 * 根据CL箱单查询原箱单号和工厂
 * @param id
 */
export const queryOriginalPackingListInfoByCLPackingList = (id: string) =>
    request({
        url: `/hq-packing-lists/${id}/original-packing-list-code`,
        method: "get"
    })